<template>
  <el-form
    :model="form"
    ref="form"
    class="dialog-form-default"
    :disabled="disabledForm"
  >
    <div class="row">
      <div class="col-12 col-md-6">
        <el-form-item
          :label="L10n('part-number')"
          prop="partNumber"
          :rules="getValidationRule('required')"
          class="material-style">
          <el-input
            :value="form.partNumber"
            @input="form.partNumber = valueTrimLeft($event)"
            @change="updateModelItem('partNumber', { required: true })"
            :disabled="!isNew"
          />
        </el-form-item>
      </div>
      <div class="col-12 col-md-6">
        <el-form-item
          :label="L10n('part-description')"
          prop="partDescription"
          :rules="getValidationRule('required')"
          class="material-style">
          <el-input
            :value="form.partDescription"
            @input="form.partDescription = valueTrimLeft($event)"
            @change="updateModelItem('partDescription', { required: true })"
          />
        </el-form-item>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-md-6">
        <el-form-item
          :label="L10n('manufacturer')"
          prop="manufacturerID"
          :rules="getValidationRule('required')"
          class="material-style">
          <select-company
            :model.sync="form.manufacturerID"
            @update:model="updateModelItem('manufacturerID', { required: true })"
            :disabled="disabledForm"
          ></select-company>
        </el-form-item>
      </div>
      <div class="col-12 col-md-6">
        <el-form-item
          :label="L10n('aircraft')"
          prop="aircraftID"
          :rules="getValidationRule('required')"
          class="material-style">
          <select-response-auto-complete
            :model.sync="form.aircraftID"
            @update:model="updateModelItem('aircraftID', { required: true })"
            api="Aircrafts/GetAllDynamic"
            :fields="{id: 'id', title: 'aircraftModel'}"
            :orderBy="{fields: 'aircraftModel', order: ''}"/>
        </el-form-item>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-md-4 price-field">
        <el-form-item
          :label="L10n('list-price')"
          prop="listPrice"
          :rules="getValidationRule('number')"
          class="price-field__field material-style">
          <el-input
            :value="form.listPrice"
            @input="form.listPrice = valueNumber($event)"
            @change="updateModelItem('listPrice')"
          />
        </el-form-item>
        <el-form-item
          prop="priceCurrencyID"
          class="price-field__value material-style">
          <select-response
            :model.sync="form.priceCurrencyID"
            @update:model="updateModelItem('priceCurrencyID')"
            :data="dataSourceCurrency.records"
            :isLoading="dataSourceCurrency.isLoading"
          ></select-response>
        </el-form-item>
      </div>
      <div class="col-12 col-md-4">
        <el-form-item
          :label="L10n('list-price-source')"
          prop="listPriceSource"
          class="material-style">
          <select-response
            :model.sync="form.listPriceSource"
            @update:model="updateModelItem('listPriceSource')"
            :fields="{ id: 'subject', title: 'subject'}"
            :data="dataSourceListPriceSource.records"
            :isLoading="dataSourceListPriceSource.isLoading"
          ></select-response>
        </el-form-item>
      </div>
      <div class="col-12 col-md-4">
        <el-form-item
          :label="L10n('list-price-date')"
          prop="listPriceDate"
          class="material-style">
          <date-picker
            type="date"
            v-model="form.listPriceDate"
            @change="updateModelItem('listPriceDate')"
          />
        </el-form-item>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-6 col-12">
        <el-form-item
          :label="L10n('remark')"
          prop="remark"
          class="material-style">
          <el-input
            type="textarea"
            :rows="3"
            v-model="form.remark"
            @change="updateModelItem('remark')"/>
        </el-form-item>
      </div>
      <div class="col-sm-6 col-12">
        <el-form-item
          :label="L10n('technical-remark')"
          prop="technicalRemark"
          class="material-style">
          <el-input
            type="textarea"
            :rows="3"
            v-model="form.technicalRemark"
            @change="updateModelItem('technicalRemark')"/>
        </el-form-item>
      </div>
    </div>
  </el-form>
</template>

<script>
import Form from '@/components/Form/Form'

export default {
  name: 'FormGeneralParts',
  mixins: [Form],
  props: {
    isNew: { type: Boolean, required: true }
  },
  components: {
    'select-company': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/SelectCompany/Index.vue')
  },
  computed: {
    dataSourceListPriceSource () {
      return this.API('CompanyRemarkSubjects/GetAllDynamic?Select=subject&Filter=tableIndex==7&OrderBy=subject')
    },
    dataSourceCurrency () {
      return this.API('Currencies/GetAllDynamic?select=id,title')
    }
  }
}
</script>
